import React from 'react';
import {useSelector} from 'react-redux';
import {BrowserRouter as Router, Route, Routes} from 'react-router-dom';

import {BASE_NAME} from '../constants';

import useScript from '../hooks/useScript.js';

import backgroundImage from '../../assets/images/faq-tile.png';
import bodyBackgroundImage from '../../assets/images/bg-image.png';

import PageNaoEncontrada from "./PageNaoEncontrada";
import PageHome from "./PageHome";
import PageDiploma from "./PageDiploma";
import PageHistoricoParcial from "./PageHistoricoParcial";

import Header from './shared/header/Header';
import LoadingModal from './shared/loadingmodal/LoadingModal';
import GlobalDialogMessage from './shared/dialogmessage/GlobalDialogMessage';
import Footer from "./shared/footer/Footer";
import ConfirmationDialogProvider from "./shared/confirmationdialog/ConfirmationDialogProvider";

import {createTheme, makeStyles, MuiThemeProvider} from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';

const newTheme = createTheme({
    typography: {
        useNextVariants: true
    },
    palette: {
        primary: {
            main: '#20356C'
        },
        secondary: {
            main: '#D2D7E2'
        },
        tertiary: {
            light: '#53b0f9',
            main: '#1672bb',
            dark: '#074b81'
        }
    },
    breakpoints: {
        values: {
            xs: 0,
            sm: 800, // Alterado de 600 para 800
            md: 960,
            lg: 1280,
            xl: 1920
        },
    },
    overrides: {
        MuiSwitch: {
            switchBase: {
                color: "#ccc"
            },
            colorSecondary: {
                "&$checked": {
                    color: "#1672bb"
                }
            },
            track: {
                opacity: 0.2,
                backgroundColor: "#7c7c7e",
                "$checked$checked + &": {
                    opacity: 0.7,
                    backgroundColor: "#1672bb"
                }
            }
        }
    }
});

const useStyles = propsStyle => makeStyles(theme => ({
    '@global': {
        'html, body, #root': {
            height: '100%',
            '-webkit-overflow-scrolling': 'touch',
        },
        html: {
            background: '#ecedf1 url(' + backgroundImage + ') 0 0 repeat',
            backgroundAttachment: 'fixed'
        },
        body: {
            background: propsStyle.showBackground ? '#ecedf1 url(' + bodyBackgroundImage + ') 0 0 repeat' : 'initial',
            [theme.breakpoints.up('sm')]: {
                background: propsStyle.showBackground ? 'url(' + bodyBackgroundImage + ') no-repeat top right fixed' : 'initial'
            }
        },
        'ul, ol': {
            margin: 0,
            padding: 0,
            listStyle: 'none'
        },
        a: {
            textDecoration: 'underline'
        },
        p: {
            marginTop: 0
        },
        '#root': {
            height: '100%'
        }
    },
    gridContainer: {
        minHeight: '100%',
        display: 'grid',
        gridTemplateRows: 'min-content 1fr min-content'
    },
}));
export default function App() {
    const propsStyle = {
        showBackground: useSelector(state => state.showBackground)
    };

    const classes = useStyles(propsStyle)();

    const showHeader = useSelector(state => state.showHeader);

    const embedded = useSelector(state => state.embedded);

    if (!embedded) {
        useScript(`https://www3.unaerp.br/Componentes/resources/scripts/acessibilidade/js/import.js`);
    }

    return (
        <Router basename={BASE_NAME}>
            <>
                <CssBaseline />
                <MuiThemeProvider theme={newTheme}>
                    <ConfirmationDialogProvider>
                        <LoadingModal />
                        <GlobalDialogMessage />
                        <div className={classes.gridContainer}>
                            {showHeader && (
                                <Header
                                    title='Diploma Digital'
                                    subtitle='Portal Unaerp' />
                            )}
                            <main>
                                <Routes>
                                    <Route path='/*' element={<PageHome />} />
                                    <Route path='/diploma' element={<PageDiploma />} />
                                    <Route path='/historicoParcial' element={<PageHistoricoParcial />} />
                                    <Route path='/pagina-nao-encontrada' element={<PageNaoEncontrada />} />
                                </Routes>
                            </main>
                            <Footer />
                        </div>
                    </ConfirmationDialogProvider>
                </MuiThemeProvider>
            </>
        </Router>
    );
}